export function ToSeoUrl(url,id) {
    if (!url){
        return ""
    }
    let encodedUrl = url.toString().toLowerCase();
    encodedUrl = encodedUrl.replace(new RegExp(/\s/g),"-");
    encodedUrl = encodedUrl.replace(new RegExp(/[đ]/g),"d");
    encodedUrl = encodedUrl.replace(new RegExp(/[àáâãäå]/g),"a");
    encodedUrl = encodedUrl.replace(new RegExp(/[ăắằặẳ]/g),"a");
    encodedUrl = encodedUrl.replace(new RegExp(/[âấầẩậ]/g),"a");
    encodedUrl = encodedUrl.replace(new RegExp(/[èéêë]/g),"e");
    encodedUrl = encodedUrl.replace(new RegExp(/[ơờớợở]/g),"o");
    encodedUrl = encodedUrl.replace(new RegExp(/[ôồốổộ]/g),"o");
    encodedUrl = encodedUrl.replace(new RegExp(/[ưừứựủ]/g),"u");
    encodedUrl = encodedUrl.replace(new RegExp(/[ìíîï]/g),"i");
    encodedUrl = encodedUrl.replace(new RegExp(/[òóôõö]/g),"o");
    encodedUrl = encodedUrl.replace(new RegExp(/[ùúûü]/g),"u");
    encodedUrl = encodedUrl.replace(new RegExp(/[ýÿ]/g),"y");
    encodedUrl = encodedUrl.replace(new RegExp(/\W/g),"-");
    // replace & with and           
    encodedUrl = encodedUrl.split(/\&+/).join("-and-")

    // remove invalid characters 
    encodedUrl = encodedUrl.split(/[^a-z0-9]/).join("-");

    // remove duplicates 
    encodedUrl = encodedUrl.split(/-+/).join("-");

    // trim leading & trailing characters 
    encodedUrl = encodedUrl.trim('-');

    return encodedUrl+'-'+id;
}
export const isHtml = (text) => {
    if (text != null && text.length > 0) {
        let html = text.match(/<.+>/g);
        return html != null;
    }
    return false;
}
export const parStr2Float = str => parseFloat(str.toString().replace(",", "."));
export const formatCash = n => {
    if (n < 1e3) return n;
    if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "k";
    if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
    if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
    if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
};